import { render } from "./eliteProspectsPlayerDialog.vue?vue&type=template&id=63b74367"
import script from "./eliteProspectsPlayerDialog.vue?vue&type=script&lang=js"
export * from "./eliteProspectsPlayerDialog.vue?vue&type=script&lang=js"

import "./eliteProspectsPlayerDialog.vue?vue&type=style&index=0&id=63b74367&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__